import axios from 'axios';
import { getEmbeddedReportUrlQuery } from './queries';

const getEmbeddedReport = async (resourceIdentifier) => {
    try {
        const query = await getEmbeddedReportUrlQuery(resourceIdentifier);
        const response = await axios.get(query.url);
        return response.data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        throw new Error(`Unable to fetch embedded report: ${error.message}`);
    }
};

export default getEmbeddedReport;
